import React, { useState, useRef, useEffect } from 'react';
import './attestationvalidation.css';
import './procesVerbal.css';
import app from './firebase.js';
import { getDatabase, ref, set, onValue, remove } from 'firebase/database';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import { Delete, Download, Eye, Edit, Plus } from 'react-feather';
import { Modal, Button, ConfigProvider, Popconfirm, message } from 'antd';
import logo from './img/edaplogo.png';
import unilislogo from './img/unilislogo.png';
import crlogo from './img/crlogo.png';
import virgilSig from './img/Virgil_sig.png';
import papaSig from './img/papa_sig.png';
import perezSig from './img/perez.png';
import rectorSig from './img/rector.png';
import bapSig from './img/bap_sig.png';

const TITLE_OPTIONS = [
    { value: 'DE DOCTORAT', label: 'DE DOCTORAT' },
    { value: 'DE MÉMOIRE DE HDR', label: 'MÉMOIRE DE HDR' },
    { value: 'DE LICENCE', label: 'Licence' },
    { value: 'DE MASTER', label: 'Master' },
];

const DEFAULT_JURY_MEMBERS = [
    { role: 'Président', name: 'Pr Nizeyimana Jean Baptiste, Professeur en informatique, Université de Lisala-RDC' },
    { role: 'Directeur', name: 'Pr Ahmed KORA, Ecole Supérieure Multinationale des Télécommunications-Senegal' },
    { role: 'Co-Directeur', name: 'Pr Guy Juanole , Professeur de protocoles des réseaux informatiques, UNCR University-USA' },
    { role: 'Rapporteur', name: 'Pr Reem Bahgat, Professeur en informatique, Université de Lisala-RDC' },
    { role: 'Membre', name: '' },
    { role: 'Membre', name: '' },
];

const getInitialFormData = () => ({
    titleType: '',
    genre: '',
    candidateName: '',
    dateNaissance: '',
    lieuNaissance: '',
    paysNaissance: '',
    numeroInscription: '',
    domaine: '',
    specialite: '',
    dateSoutenance: '',
    universite: '',
    titreTravail: '',
    typeDiplome: '',
    titreObtenu: '',
    mention: '',
    juryMembers: DEFAULT_JURY_MEMBERS.map((m) => ({ ...m })),
    lieuFait: '',
    dateFait: '',
    signatureSecretaireTitre: '',
    signatureSecretaireNom: '',
    signatureDirecteurTitre: '',
    signatureDirecteurNom: '',
    signatureRecteurTitre: '',
    signatureRecteurNom: '',
});

const formatDateWithMonthName = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const months = [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
    ];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
};

const formatDateShort = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
};

const formatDateWithMonthNameEnglish = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

const ProcesVerbal = () => {
    const [formData, setFormData] = useState(() => ({
        ...getInitialFormData(),
        dateSoutenance: new Date().toISOString().split('T')[0],
        dateFait: new Date().toISOString().split('T')[0],
    }));
    const [documents, setDocuments] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [qrCodeData, setQrCodeData] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const db = getDatabase(app);

    useEffect(() => {
        const refPath = ref(db, 'procesVerbal/UNCR/');
        onValue(refPath, (snapshot) => {
            const data = snapshot.val();
            if (data) {
                const arr = Object.keys(data).map((key) => ({ id: key, ...data[key] }));
                arr.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
                setDocuments(arr);
            } else {
                setDocuments([]);
            }
        });
    }, [db]);

    useEffect(() => {
        const generateQR = async () => {
            if (!selectedDocument) return;
            let qrData = `PROCÈS VERBAL DE SOUTENANCE - UNILIS/UNCR\n`;
            Object.keys(selectedDocument).forEach((key) => {
                if (key !== 'createdAt' && selectedDocument[key]) qrData += `${key}: ${selectedDocument[key]}\n`;
            });
            qrData += `Status: Document Verified\nIssued by: UNILIS - Université de Lisala`;
            try {
                const url = await QRCode.toDataURL(qrData, {
                    width: 256,
                    margin: 2,
                    errorCorrectionLevel: 'M',
                    color: { dark: '#000000', light: '#FFFFFF' },
                });
                setQrCodeData(url);
            } catch (err) {
                console.error(err);
                setQrCodeData(null);
            }
        };
        generateQR();
    }, [selectedDocument]);

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape' && modalVisible) handleModalClose();
        };
        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [modalVisible]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const normalizeJuryMembers = (doc) => {
        if (doc.juryMembers && Array.isArray(doc.juryMembers) && doc.juryMembers.length > 0) return doc.juryMembers;
        return [
            { role: 'Président', name: doc.juryPresident || '' },
            { role: 'Directeur', name: doc.juryDirecteur || '' },
            { role: 'Rapporteur', name: doc.juryRapporteur || '' },
            { role: 'Membre', name: doc.juryMembre1 || '' },
            { role: 'Membre', name: doc.juryMembre2 || '' },
        ];
    };

    const addJuryMember = () => setFormData((prev) => ({ ...prev, juryMembers: [...(prev.juryMembers || []), { role: 'Membre', name: '' }] }));

    const updateJuryMember = (index, name) => setFormData((prev) => {
        const juryMembers = [...(prev.juryMembers || DEFAULT_JURY_MEMBERS.map((m) => ({ ...m })))];
        if (juryMembers[index]) juryMembers[index] = { ...juryMembers[index], name };
        return { ...prev, juryMembers };
    });

    const resetForm = () => {
        setFormData({
            ...getInitialFormData(),
            dateSoutenance: new Date().toISOString().split('T')[0],
            dateFait: new Date().toISOString().split('T')[0],
        });
        setIsEditing(false);
        setEditingId(null);
    };

    const handleEditDocument = (doc) => {
        setFormData({
            ...getInitialFormData(),
            titleType: doc.titleType || '',
            genre: doc.genre || '',
            candidateName: doc.candidateName || '',
            dateNaissance: doc.dateNaissance || '',
            lieuNaissance: doc.lieuNaissance || '',
            paysNaissance: doc.paysNaissance || '',
            numeroInscription: doc.numeroInscription || '',
            domaine: doc.domaine || '',
            specialite: doc.specialite || '',
            dateSoutenance: doc.dateSoutenance || new Date().toISOString().split('T')[0],
            universite: doc.universite || '',
            titreTravail: doc.titreTravail || '',
            typeDiplome: doc.typeDiplome || '',
            titreObtenu: doc.titreObtenu || '',
            mention: doc.mention || '',
            juryMembers: normalizeJuryMembers(doc),
            lieuFait: doc.lieuFait || '',
            dateFait: doc.dateFait || new Date().toISOString().split('T')[0],
            signatureSecretaireTitre: doc.signatureSecretaireTitre ?? '',
            signatureSecretaireNom: doc.signatureSecretaireNom ?? '',
            signatureDirecteurTitre: doc.signatureDirecteurTitre ?? '',
            signatureDirecteurNom: doc.signatureDirecteurNom ?? '',
            signatureRecteurTitre: doc.signatureRecteurTitre ?? '',
            signatureRecteurNom: doc.signatureRecteurNom ?? '',
        });
        setIsEditing(true);
        setEditingId(doc.id);
        handleModalClose();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.candidateName?.trim() || !formData.numeroInscription?.trim()) {
            message.warning('Nom du candidat et numéro d\'inscription sont obligatoires.');
            return;
        }
        const id = formData.numeroInscription.replace(/\s+/g, '_') || `pv_${Date.now()}`;
        const docRef = ref(db, `procesVerbal/UNCR/${id}`);
        const payload = { ...formData, createdAt: isEditing && editingId ? (documents.find((d) => d.id === editingId)?.createdAt || new Date().toISOString()) : new Date().toISOString() };
        const pathId = isEditing && editingId ? editingId : id;
        const updateRef = ref(db, `procesVerbal/UNCR/${pathId}`);

        set(updateRef, payload)
            .then(() => {
                message.success(isEditing ? 'Procès-verbal modifié.' : 'Procès-verbal enregistré.');
                resetForm();
            })
            .catch((err) => {
                console.error(err);
                message.error('Erreur lors de l\'enregistrement.');
            });
    };

    const handleModalClose = () => {
        setModalVisible(false);
        setSelectedDocument(null);
    };

    const showModal = (doc) => {
        setSelectedDocument(doc);
        setModalVisible(true);
    };

    const handleDelete = (id) => {
        remove(ref(db, `procesVerbal/UNCR/${id}`))
            .then(() => message.success('Document supprimé.'))
            .catch(() => message.error('Erreur lors de la suppression.'));
    };

    const downloadPDF = async (doc) => {
        const frenchEl = document.getElementById(`proces-verbal-${doc.id}-french`);
        const englishEl = document.getElementById(`proces-verbal-${doc.id}-english`);
        if (!frenchEl) return;
        const pdf = new jsPDF('p', 'pt', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const renderPage = async (el) => {
            const clone = el.cloneNode(true);
            clone.style.width = '21cm';
            clone.style.minHeight = '29.7cm';
            clone.style.margin = '0';
            clone.style.padding = '1.4cm 0.8cm';
            clone.style.background = 'white';
            clone.style.fontFamily = "'Times New Roman', serif";
            clone.style.boxSizing = 'border-box';
            const tmp = document.createElement('div');
            tmp.style.cssText = 'position: fixed; top: -9999px; left: -9999px; z-index: -1; width: 21cm;';
            tmp.appendChild(clone);
            document.body.appendChild(tmp);
            const imgs = clone.querySelectorAll('img');
            await Promise.all(Array.from(imgs).map((img) => new Promise((res) => { if (img.complete) res(); else { img.onload = res; img.onerror = res; } })));
            await new Promise((r) => setTimeout(r, 300));
            const canvas = await html2canvas(clone, { scale: 2, useCORS: true, backgroundColor: '#FFFFFF', windowWidth: clone.scrollWidth, windowHeight: clone.scrollHeight });
            document.body.removeChild(tmp);
            const ratio = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);
            const w = canvas.width * ratio;
            const h = canvas.height * ratio;
            const x = (pageWidth - w) / 2;
            const y = (pageHeight - h) / 2;
            return { img: canvas.toDataURL('image/png'), w, h, x, y };
        };

        try {
            const page1 = await renderPage(frenchEl);
            pdf.addImage(page1.img, 'PNG', page1.x, page1.y, page1.w, page1.h);
            if (englishEl) {
                const page2 = await renderPage(englishEl);
                pdf.addPage();
                pdf.addImage(page2.img, 'PNG', page2.x, page2.y, page2.w, page2.h);
            }
            pdf.save(`Proces_Verbal_${(doc.candidateName || doc.id).replace(/\s+/g, '_')}.pdf`);
        } catch (err) {
            console.error(err);
            message.error('Erreur lors de la génération du PDF');
        }
    };

    return (
        <div className="UNCR proces-verbal-page">
            <div className="pv-form-container">
                <div className="pv-form-header">
                    <img src={logo} alt="Logo UNCR" className="pv-form-logo" />
                    <h2>Procès Verbal de Soutenance – Thèse / Mémoire de HDR</h2>
                </div>

                <form onSubmit={handleSubmit} className="pv-form">
                    <div className="pv-form-row">
                        <div className="pv-form-group">
                            <label>Type de document (titre)</label>
                            <select
                                name="titleType"
                                value={formData.titleType}
                                onChange={handleInputChange}
                            >
                                <option value="">—</option>
                                {TITLE_OPTIONS.map((o) => (
                                    <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                            </select>
                        </div>
                        <div className="pv-form-group">
                            <label>Genre</label>
                            <select name="genre" value={formData.genre} onChange={handleInputChange}>
                                <option value="">—</option>
                                <option value="Monsieur">Monsieur</option>
                                <option value="Madame">Madame</option>
                            </select>
                        </div>
                    </div>

                    <div className="pv-form-group">
                        <label>Nom complet du candidat</label>
                        <input
                            type="text"
                            name="candidateName"
                            value={formData.candidateName}
                            onChange={handleInputChange}
                            placeholder="Ex: EDOH THIERRY OSCAR CODJO"
                            required
                        />
                    </div>

                    <div className="pv-form-row three-cols">
                        <div className="pv-form-group">
                            <label>Date de naissance</label>
                            <input
                                type="date"
                                name="dateNaissance"
                                value={formData.dateNaissance}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div className="pv-form-group">
                            <label>Lieu de naissance</label>
                            <input
                                type="text"
                                name="lieuNaissance"
                                value={formData.lieuNaissance}
                                onChange={handleInputChange}
                                placeholder="Ex: COTONOU"
                            />
                        </div>
                        <div className="pv-form-group">
                            <label>Pays de naissance</label>
                            <input
                                type="text"
                                name="paysNaissance"
                                value={formData.paysNaissance}
                                onChange={handleInputChange}
                                placeholder="Ex: BENIN"
                            />
                        </div>
                    </div>

                    <div className="pv-form-row">
                        <div className="pv-form-group">
                            <label>Numéro d'inscription</label>
                            <input
                                type="text"
                                name="numeroInscription"
                                value={formData.numeroInscription}
                                onChange={handleInputChange}
                                placeholder="Ex: 008HDR24"
                                required
                            />
                        </div>
                        <div className="pv-form-group">
                            <label>Domaine</label>
                            <input
                                type="text"
                                name="domaine"
                                value={formData.domaine}
                                onChange={handleInputChange}
                                placeholder="Sciences et Technologies"
                            />
                        </div>
                        <div className="pv-form-group">
                            <label>Spécialité</label>
                            <input
                                type="text"
                                name="specialite"
                                value={formData.specialite}
                                onChange={handleInputChange}
                                placeholder="Informatique"
                            />
                        </div>
                    </div>

                    <div className="pv-form-row">
                        <div className="pv-form-group">
                            <label>Date de soutenance</label>
                            <input
                                type="date"
                                name="dateSoutenance"
                                value={formData.dateSoutenance}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="pv-form-group flex2">
                            <label>Université (lieu de soutenance)</label>
                            <input
                                type="text"
                                name="universite"
                                value={formData.universite}
                                onChange={handleInputChange}
                                placeholder="l'Université de Lisala"
                            />
                        </div>
                    </div>

                    <div className="pv-form-group">
                        <label>Titre du travail soutenu</label>
                        <textarea
                            name="titreTravail"
                            value={formData.titreTravail}
                            onChange={handleInputChange}
                            placeholder="Titre complet de la thèse / mémoire"
                            rows={3}
                        />
                    </div>

                    <div className="pv-form-row">
                        <div className="pv-form-group">
                            <label>Type diplôme (jury)</label>
                            <select name="typeDiplome" value={formData.typeDiplome} onChange={handleInputChange}>
                                <option value="">—</option>
                                <option value="Licence">Licence</option>
                                <option value="Master">Master</option>
                                <option value="Doctorat">Doctorat</option>
                                <option value="HDR">HDR</option>
                            </select>
                        </div>
                        <div className="pv-form-group">
                            <label>Titre déclaré</label>
                            <select name="titreObtenu" value={formData.titreObtenu} onChange={handleInputChange}>
                                <option value="">—</option>
                                <option value="Licencié(e)">Licencié(e)</option>
                                <option value="Master">Master</option>
                                <option value="Docteur">Docteur</option>
                                <option value="HDR">HDR</option>
                            </select>
                        </div>
                        <div className="pv-form-group flex2">
                            <label>Mention</label>
                            <select name="mention" value={formData.mention} onChange={handleInputChange}>
                                <option value="">—</option>
                                <option value="Très Honorable avec Félicitations du jury">Très Honorable avec Félicitations du jury</option>
                                <option value="Très Honorable">Très Honorable</option>
                                <option value="Honorable">Honorable</option>
                                <option value="Bien">Bien</option>
                                <option value="Assez Bien">Assez Bien</option>
                            </select>
                        </div>
                    </div>

                    <div className="pv-form-section-label">Jury</div>
                    {(formData.juryMembers || DEFAULT_JURY_MEMBERS.map((m) => ({ ...m }))).map((member, index) => (
                        <div key={index} className="pv-form-row" style={{ alignItems: 'flex-end' }}>
                            <div className="pv-form-group" style={{ flex: '0 0 120px' }}>
                                <label>{member.role}</label>
                                <input type="text" value={member.role} readOnly disabled style={{ background: '#f0f0f0', cursor: 'default' }} />
                            </div>
                            <div className="pv-form-group flex2">
                                <label>Nom, titre, affiliation</label>
                                <input
                                    type="text"
                                    value={member.name}
                                    onChange={(e) => updateJuryMember(index, e.target.value)}
                                    placeholder="Pr Nom, Titre, Affiliation"
                                />
                            </div>
                        </div>
                    ))}
                    <div className="pv-form-group">
                        <button type="button" className="pv-add-member-btn" onClick={addJuryMember}><Plus size={18} /> Ajouter un membre</button>
                    </div>

                    <div className="pv-form-row">
                        <div className="pv-form-group">
                            <label>Fait à (lieu)</label>
                            <input
                                type="text"
                                name="lieuFait"
                                value={formData.lieuFait}
                                onChange={handleInputChange}
                                placeholder="Lisala"
                            />
                        </div>
                        <div className="pv-form-group">
                            <label>Date (Fait à)</label>
                            <input
                                type="date"
                                name="dateFait"
                                value={formData.dateFait}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>

                    <div className="pv-form-group full-width">
                        <button type="submit" className="pv-submit-btn">{isEditing ? 'Modifier le Procès-Verbal' : 'Enregistrer le Procès-Verbal'}</button>
                        {isEditing && (
                            <button type="button" onClick={resetForm} className="pv-submit-btn" style={{ marginTop: '10px', background: 'linear-gradient(135deg, #6c757d, #5a6268)' }}>Annuler</button>
                        )}
                    </div>
                </form>

                <div className="pv-search-bar">
                    <input
                        type="text"
                        placeholder="Rechercher par nom ou numéro..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>

                <div className="pv-document-list">
                    {documents
                        .filter(
                            (d) =>
                                (d.candidateName || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                                (d.numeroInscription || '').toLowerCase().includes(searchQuery.toLowerCase())
                        )
                        .map((doc) => (
                            <div key={doc.id} className="pv-document-item">
                                <button type="button" className="pv-view-btn" onClick={() => showModal(doc)}>
                                    <Eye size={16} />
                                    {doc.candidateName || doc.id} – {doc.numeroInscription}
                                </button>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                    <button type="button" className="pv-edit-btn" onClick={() => handleEditDocument(doc)} title="Modifier" aria-label="Modifier">
                                        <Edit size={15} />
                                    </button>
                                    <Popconfirm
                                        title="Supprimer le document"
                                        description="Êtes-vous sûr de vouloir supprimer ce procès-verbal ?"
                                        onConfirm={() => handleDelete(doc.id)}
                                        okText="Oui"
                                        cancelText="Non"
                                        okButtonProps={{ danger: true }}
                                    >
                                        <button type="button" className="pv-delete-btn" aria-label="Supprimer"><Delete size={15} /></button>
                                    </Popconfirm>
                                </div>
                            </div>
                        ))}
                </div>
            </div>

            <ConfigProvider>
                <Modal
                    title={<span style={{ color: 'white' }}>Procès Verbal – {selectedDocument?.candidateName || ''}</span>}
                    open={modalVisible}
                    onCancel={handleModalClose}
                    width="95vw"
                    style={{ top: 10 }}
                    className="pv-modal"
                    footer={[
                        <Button
                            key="download"
                            type="primary"
                            icon={<Download size={16} />}
                            onClick={() => selectedDocument && downloadPDF(selectedDocument)}
                            style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}
                        >
                            Télécharger PDF
                        </Button>,
                        <Button key="close" onClick={handleModalClose}>Fermer</Button>,
                    ]}
                >
                    {selectedDocument && (
                        <div className="pv-modal-content pv-two-pages">
                            <ProcesVerbalDocument formData={selectedDocument} id={selectedDocument.id} qrCodeData={qrCodeData} lang="french" />
                            <ProcesVerbalDocument formData={selectedDocument} id={selectedDocument.id} qrCodeData={qrCodeData} lang="english" />
                        </div>
                    )}
                </Modal>
            </ConfigProvider>
        </div>
    );
};

const TITLE_EN = {
    'DE DOCTORAT': 'PhD DEGREE',
    'DE MÉMOIRE DE HDR': 'HDR MEMOIR',
    'MÉMOIRE DE HDR': 'HDR MEMOIR',
    'DE LICENCE': 'Bachelor\'s Degree',
    'LICENSE': 'Bachelor\'s Degree',
    'DE MASTER': 'Master\'s Degree',
    'MASTER': 'Master\'s Degree',
};
const TITRE_OBTENU_EN = { 'Licencié(e)': 'Bachelor\'s degree holder', 'Master': 'Master', 'Docteur': 'Doctor', 'HDR': 'HDR' };

const ProcesVerbalDocument = ({ formData, id, qrCodeData, lang }) => {
    const isEnglish = lang === 'english';
    const isFem = formData.genre === 'Madame';
    const g = (masc, fem) => (isFem ? fem : masc);
    const dateSoutenanceShort = formatDateShort(formData.dateSoutenance);
    const dateFaitLong = isEnglish ? formatDateWithMonthNameEnglish(formData.dateFait) : formatDateWithMonthName(formData.dateFait);
    const birthDateStr = formData.dateNaissance
        ? (isEnglish ? formatDateWithMonthNameEnglish(formData.dateNaissance) : new Date(formData.dateNaissance).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }))
        : '—';
    const juryList = formData.juryMembers && Array.isArray(formData.juryMembers) && formData.juryMembers.length > 0
        ? formData.juryMembers
        : [
            { role: 'Président', name: formData.juryPresident },
            { role: 'Directeur', name: formData.juryDirecteur },
            { role: 'Rapporteur', name: formData.juryRapporteur },
            { role: 'Membre', name: formData.juryMembre1 },
            { role: 'Membre', name: formData.juryMembre2 },
        ].map((m) => ({ ...m, name: m.name || '—' }));
    const roleLabel = (role) => (isEnglish ? (role === 'Président' ? 'Chair' : role === 'Directeur' ? 'Director' : role === 'Co-Directeur' ? 'Co-Director' : role === 'Rapporteur' ? 'Rapporteur' : 'Member') : role);

    /* French header: line 1 never includes "THESE"; line 2 = DE DOCTORAT / DE MASTER / DE LICENCE / MÉMOIRE HDR */
    const isMemoireHdr = formData.titleType === 'DE MÉMOIRE DE HDR' || formData.titleType === 'MÉMOIRE DE HDR';
    const mainTitleFr = 'PROCES VERBAL DE SOUTENANCE DE';
    const subtitleFr = (() => {
        const t = formData.titleType || '';
        if (isMemoireHdr) return 'MÉMOIRE DE HDR';
        if (!t) return '—';
        if (t.startsWith('DE ')) return t;
        if (t === 'LICENSE') return 'DE LICENCE';
        if (t === 'MASTER') return 'DE MASTER';
        return `DE ${t}`;
    })();

    return (
        <div id={`proces-verbal-${id}-${lang}`} className="attestation-validation-document proces-verbal-doc pv-page">
            <div className="attestation-validation-header">
                <div className="attestation-validation-header-row">
                    <div className="attestation-validation-left-logo">
                        <img src={unilislogo} alt="Logo UNILIS" className="attestation-validation-logo" />
                        <div className="attestation-validation-left-text">
                            <h1 className="attestation-validation-school">{isEnglish ? 'DOCTORAL SCHOOL' : 'ECOLE DOCTORALE'}</h1>
                            <h2 className="attestation-validation-subtitle">{isEnglish ? 'International Joint Thesis and Co-diploma' : 'Cotutelle Internationale de Thèse et Co-diplomation'}</h2>
                        </div>
                    </div>
                    <div className="attestation-validation-header-center">
                        <h3 className="attestation-validation-university">UNIVERSITY OF LISALA</h3>
                        <p className="attestation-validation-center">{isEnglish ? 'Interuniversity Center for Multidisciplinary Research (Cirep)' : 'Centre Interuniversitaire de Recherche Pluridisciplinaire (Cirep)'}</p>
                        <p className="attestation-validation-status">Status: Public university</p>
                        <p className="attestation-validation-web">Web: www.universitedelisala.ac.cd</p>
                        <p className="attestation-validation-email">Email: info@universitedelisala.ad.cd</p>
                    </div>
                    <div className="attestation-validation-right-logo">
                        <img src={crlogo} alt="Logo CRN" className="attestation-validation-logo" />
                    </div>
                </div>
            </div>

            <div className="attestation-validation-separator" />

            <div className="attestation-validation-title-section">
                <h1 className="attestation-validation-main-title">{isEnglish ? 'MINUTES OF DEFENSE' : mainTitleFr}</h1>
                <h1 className="pv-title-sub">{isEnglish ? (TITLE_EN[formData.titleType] || formData.titleType || '—') : subtitleFr}</h1>
            </div>

            <div className="pv-body attestation-validation-document-body">
                {isEnglish ? (
                    <>
                        <p className="pv-paragraph">
                            {formData.genre === 'Madame' ? 'Ms.' : 'Mr.'} <span className="pv-variable">{formData.candidateName || '—'}</span>, born on <span className="pv-variable">{birthDateStr}</span> in <span className="pv-variable">{formData.lieuNaissance || '—'}</span>, <span className="pv-variable">{formData.paysNaissance || '—'}</span>; registered at {formData.universite || 'University of Lisala'} in joint supervision and co-diploma with UNCR University under number <span className="pv-variable">{formData.numeroInscription || '—'}</span> in <span className="pv-variable">{formData.domaine || 'Science and Technology'}</span>; Specialty: <span className="pv-variable">{formData.specialite || 'Computer Science'}</span>, defended {g('his', 'her')} thesis/memoir on <span className="pv-variable">{dateSoutenanceShort || '—'}</span> at {formData.universite || 'University of Lisala'}.
                        </p>
                        <p className="pv-paragraph">Title of the work defended: «<span className="pv-variable">{formData.titreTravail || '—'}</span>»</p>
                        <p className="pv-paragraph">
                            The members of the jury listed below had {g('him', 'her')} defend {g('his', 'her')} thesis/memoir for <span className="pv-variable">{formData.typeDiplome || '—'}</span> and declared {g('him', 'her')} worthy of the title of <span className="pv-variable">{TITRE_OBTENU_EN[formData.titreObtenu] || formData.titreObtenu || '—'}</span> in <span className="pv-variable">{formData.domaine || '—'} ; Specialty: {formData.specialite || '—'}</span> with the distinction: <span className="pv-variable">{formData.mention || '—'}</span>.
                        </p>
                        <div className="pv-jury">
                            {juryList.map((member, i) => (
                                <p key={i}><strong>{roleLabel(member.role)} :</strong> <span className="pv-variable">{member.name || '—'}</span></p>
                            ))}
                        </div>
                        <p className="pv-fait">Done at <span className="pv-variable">{formData.lieuFait || 'Lisala'}</span>, on <span className="pv-variable">{dateFaitLong || '—'}</span></p>
                        <div className="pv-signatures">
                            <div className="pv-sig-row">
                                <div className="pv-sig-block">
                                    <p className="pv-sig-title">{formData.signatureSecretaireTitre || 'Jury Secretary'}</p>
                                    <p className="pv-sig-name">{formData.signatureSecretaireNom || 'Pr Ahyi Virgile / IRGIB Africa'}</p>
                                    <img src={virgilSig} alt="" className="pv-sig-img" />
                                </div>
                                <div className="pv-sig-block">
                                    <p className="pv-sig-title">Jury Secretary</p>
                                    <p className="pv-sig-name">NZEYIMANA Isaie / University of Rwanda</p>
                                    <img src={papaSig} alt="" className="pv-sig-img" />
                                </div>
                            </div>
                            <div className="pv-sig-row">
                                <div className="pv-sig-block">
                                    <p className="pv-sig-title">{formData.signatureDirecteurTitre || "Director of the Doctoral School / UNCR University"}</p>
                                    <p className="pv-sig-name">{formData.signatureDirecteurNom || 'Pr Jean Luc Perez'}</p>
                                    <img src={perezSig} alt="" className="pv-sig-img" />
                                </div>
                                <div className="pv-sig-block">
                                    <p className="pv-sig-title">General Director of Cirep</p>
                                    <p className="pv-sig-name">NIZEYIMANA Jean-Baptiste</p>
                                    <img src={bapSig} alt="" className="pv-sig-img" />
                                </div>
                            </div>
                            <div className="pv-sig-row">
                                <div className="pv-sig-block">
                                    <p className="pv-sig-title">{formData.signatureRecteurTitre || 'Rector of the University of Lisala'}</p>
                                    <p className="pv-sig-name">{formData.signatureRecteurNom || 'Pr Abbé TEBAKABE ALOMO Donat'}</p>
                                    <img src={rectorSig} alt="" className="pv-sig-img" />
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <p className="pv-paragraph">
                            {formData.genre === 'Madame' ? 'Madame' : 'Monsieur'}{' '}
                            <span className="pv-variable">{formData.candidateName || '—'}</span>, {g('né', 'née')} le <span className="pv-variable">{birthDateStr}</span> à <span className="pv-variable">{formData.lieuNaissance || '—'}</span> au <span className="pv-variable">{formData.paysNaissance || '—'}</span> ; {g('inscrit', 'inscrite')} à {formData.universite || "l'Université de Lisala"} en cotutelle et codiplomation avec l'UNCR University sous le numéro <span className="pv-variable">{formData.numeroInscription || '—'}</span> en <span className="pv-variable">{formData.domaine || 'Sciences et Technologies'}</span> ; Spécialité : <span className="pv-variable">{formData.specialite || 'Informatique'}</span> a soutenu son travail de recherce en date du <span className="pv-variable">{dateSoutenanceShort || '—'}</span> à {formData.universite || "l'Université de Lisala"}.
                        </p>
                        <p className="pv-paragraph">Titre du travail soutenu : «<span className="pv-variable">{formData.titreTravail || '—'}</span>»</p>
                        <p className="pv-paragraph">
                            Les membres du jury ci-repris lui ont fait soutenir son travail de recherce de <span className="pv-variable">{formData.typeDiplome || '—'}</span> et lui ont {g('déclaré', 'déclarée')} digne du titre de <span className="pv-variable">{formData.titreObtenu || '—'}</span> en <span className="pv-variable">{formData.domaine || '—'} ; Spécialité : {formData.specialite || '—'}</span> avec la mention : <span className="pv-variable">{formData.mention || '—'}</span>.
                        </p>
                        <div className="pv-jury">
                            {juryList.map((member, i) => (
                                <p key={i}><strong>{member.role} :</strong> <span className="pv-variable">{member.name || '—'}</span></p>
                            ))}
                        </div>
                        <p className="pv-fait">Fait à <span className="pv-variable">{formData.lieuFait || 'Lisala'}</span>, le <span className="pv-variable">{dateFaitLong || '—'}</span></p>
                        <div className="pv-signatures">
                            <div className="pv-sig-row">
                                <div className="pv-sig-block">
                                    <p className="pv-sig-title">{formData.signatureSecretaireTitre || "Le Secrétaire du Jury"}</p>
                                    <p className="pv-sig-name">{formData.signatureSecretaireNom || 'Pr Ahyi Virgile / IRGIB Africa'}</p>
                                    <img src={virgilSig} alt="" className="pv-sig-img" />
                                </div>
                                <div className="pv-sig-block">
                                    <p className="pv-sig-title">Le Secrétaire du Jury</p>
                                    <p className="pv-sig-name">NZEYIMANA Isaie / Université du Rwanda</p>
                                    <img src={papaSig} alt="" className="pv-sig-img" />
                                </div>
                            </div>
                            <div className="pv-sig-row">
                                <div className="pv-sig-block">
                                    <p className="pv-sig-title">{formData.signatureDirecteurTitre || "Le Directeur de l'Ecole Doctorale/UNCR University"}</p>
                                    <p className="pv-sig-name">{formData.signatureDirecteurNom || 'Pr Jean Luc Perez'}</p>
                                    <img src={perezSig} alt="" className="pv-sig-img" />
                                </div>
                                <div className="pv-sig-block">
                                    <p className="pv-sig-title">Directeur Général du Cirep</p>
                                    <p className="pv-sig-name">NIZEYIMANA Jean-Baptiste</p>
                                    <img src={bapSig} alt="" className="pv-sig-img" />
                                </div>
                            </div>
                            <div className="pv-sig-row">
                                <div className="pv-sig-block">
                                    <p className="pv-sig-title">{formData.signatureRecteurTitre || "Le Recteur de l'Université de Lisala"}</p>
                                    <p className="pv-sig-name">{formData.signatureRecteurNom || 'Pr Abbé TEBAKABE ALOMO Donat'}</p>
                                    <img src={rectorSig} alt="" className="pv-sig-img" />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

            {qrCodeData && (
                <div className="pv-qr-container" aria-hidden="true">
                    <img src={qrCodeData} alt="QR Code" className="pv-qr-code" />
                </div>
            )}
        </div>
    );
};

export default ProcesVerbal;
